import { render } from "./CareersForm.vue?vue&type=template&id=38239c8b&scoped=true"
import script from "./CareersForm.vue?vue&type=script&lang=js"
export * from "./CareersForm.vue?vue&type=script&lang=js"

import "./CareersForm.vue?vue&type=style&index=0&id=38239c8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38239c8b"]])

export default __exports__